import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@fluentui/react/lib/Stack';
import {
  Caption1,
  Caption1Strong,
} from '@fluentui/react-components';
import { useStyles } from './styles';

export const ConfidenceLevel = ({ value }) => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);
  const label = i18n.getString(_TL_('Confidence level'));
  const learnMore = i18n.getString(_TL_('Click to learn more about'));

  return (
    <Stack>
      <div className={styles.label}>
        <Caption1>{label}</Caption1>
        <HelpButton
          aria-label={`${learnMore} ${label}`}
          topic="pop_BA_Experiments_Confidence"
        />
      </div>
      <Caption1Strong>{value}</Caption1Strong>
    </Stack>
  );
};

ConfidenceLevel.propTypes = {
  value: PropTypes.string.isRequired,
};
